window.rtp_i18next = require("./i18next.js");

export default function initInternationalization (language) {
  var supportedLangs = ['en', 'es'];
  var lang = language ?? getSystemLocale();
  const translationData = require('../locales/combinedTranslationsOutput.json');
  rtp_i18next.init({
    lng: lang,
    preload: supportedLangs,
    lngWhitelist: supportedLangs,
    useCookie: false,
    resources: translationData,
    fallbackLng: 'en'
  },
  function (err, t) {
    if(err){
      console.log('translation failed!!');
    }
  });
};

var getSystemLocale = function(){
  return convertToLangCode(window.navigator.userLanguage || window.navigator.language);
};

var convertToLangCode = function(lang){
  if(typeof lang === 'string'){
      return lang.split('-')[0];
  }
};

